import "./styles.sass";
import { useHandler } from "./handler";
import assets from "../../assets";

export const AdminAsyncQuizRoom = ({ roomCode, setShowLeaderboard }) => {
  const { quizResult, search, getQuizResult, closeRoom, setSearch } =
    useHandler({
      roomCode,
      setShowLeaderboard,
    });

  const submittedStudents =
    quizResult?.submitted?.map((item) => ({
      name: item.nickname,

      status: "Submitted",

      score: item.score,

      maxScore: item.max_score,

      attempts: `${item.attempts_used}/${quizResult?.max_attempts}`,

      time: new Date(item.submitted_at).toLocaleTimeString(),
    })) || [];

  const pendingStudents =
    quizResult?.not_started?.map((item) => ({
      name: item.nickname,

      status: "Not Submitted",

      score: 0,

      maxScore: 1000,

      attempts: "-",

      time: "-",
    })) || [];

  const students = [...submittedStudents, ...pendingStudents];
  const filteredStudents = students.filter((student) =>
    student.name.toLowerCase().includes(search.toLowerCase()),
  );

  const avgScore = quizResult?.submitted?.length
    ? Math.round(
        quizResult.submitted.reduce((acc, item) => acc + item.score, 0) /
          quizResult.submitted.length,
      )
    : 0;
  return (
    <section className="async-page">
      {/* HEADER */}
      <section className="room-header">
        <section>
          <h3>
            {quizResult?.chapter || quizResult?.lesson || "Async Quiz Room"}
          </h3>{" "}
          <span> Room Code: {quizResult?.room_code}</span>
        </section>
        <section className="deadlin-card">
          <section className="deadline-wrapper">
            <img src={assets.ic_deadline} alt="time" />
            <h4 className="dead-line">
              {" "}
              Deadline:{" "}
              {new Date(quizResult?.deadline).toLocaleString("en-US", {
                month: "short",
                day: "numeric",
                year: "numeric",
                hour: "numeric",
                minute: "2-digit",
                hour12: true,
              })}
            </h4>
          </section>

          <section className="close-room-btn" onClick={closeRoom}>
            <button >Close Room</button>
            <img src={assets.ic_cancel} alt="cancel" />
          </section>
        </section>
      </section>

      {/* STATS */}
      <section className="stats">
        <section className="card rating-card">
          <section>
            <p>Joined</p>
            <h2>{quizResult?.total_joined}</h2>
          </section>
          <section className="deadlin-card">
            <img src={assets.ic_joined} alt="joined" />
          </section>
        </section>
        <section className="card rating-card">
          <section>
          <p>Submitted</p>
          <h2>{quizResult?.total_submitted}</h2></section>
          <section className="deadlin-card">
            <img src={assets.ic_submitted} alt="submitted" />
          </section>
        </section>
        <section className="card rating-card">
          <section >
            <p>Avg Score</p>
            <h2>{avgScore} pts</h2>
          </section>

          <section className="deadlin-card">
            <img src={assets.ic_scores} alt="score" />
          </section>
        </section>
      </section>

      {/* TABLE */}
      {quizResult?.total_joined > 0 && (
        <section className="progress-card">
          <section className="table-header">
            <h4> <span>● </span>Live Progress</h4>

            <section className="actions">
              <section className="quiz-search-bar">
              <img src={assets.ic_search} alt="search" />
              <input
                placeholder="Search students..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              /></section>
              <button
                onClick={() => {
                  setSearch("");
                  getQuizResult();
                }}
              >
                <img src={assets.ic_refresh} />
                Refresh
              </button>
            </section>
          </section>

          <section className="table">
            <section className="thead">
              <span>Student</span>
              <span>Status</span>
              <span>Score</span>
              <span>Attempts</span>
              <span>Submitted Time</span>
            </section>

            {filteredStudents?.map((s, i) => (
              <section className="table-row" key={i}>
                <span className="student">
                  <section className="avatar-pic">{s.name[0]}</section>
                  {s.name}
                </span>

                <span
                  className={`status ${s.status.toLowerCase().replace(" ", "-")}`}
                >
                  {s.status}
                </span>

                <span className="score">
                  {s.score} / 1000
                  <section className="bar">
                    <section
                      className="fill"
                      style={{
                        width: `${(s.score / s.maxScore) * 100}%`,
                      }}
                    ></section>
                  </section>
                </span>

                <span>{s.attempts}</span>
                <span>{s.time}</span>
              </section>
            ))}
          </section>
        </section>
     )}
    </section>
  );
};
